import { Injectable } from '@angular/core';
import { ConfigService } from 'providers/config.service';
import { AuthService } from 'providers/auth.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SharingApiService {
    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private config: ConfigService
    ) {}

    /**
     * POST new charging station tenancy aka. sharing a station to another Tenant
     */
    async postChargingStationTenancy(
        body: PostChargingStationTenancyRequest
    ): Promise<PostChargingStationTenancyResponse> {
        return this.http
            .post<PostChargingStationTenancyResponse>(`${this.config.restApiUrl}/sharing/station`, body, {
                headers: {
                    Authorization: `Bearer ${this.authService.jwt}`,
                },
            })
            .toPromise();
    }

    /**
     * DELETE charging station tenancy aka. stop sharing a station to another Tenant
     */
    async deleteChargingStationTenancy(
        body: DeleteChargingStationTenancyRequest
    ): Promise<DeleteChargingStationTenancyResponse> {
        return this.http
            .delete<DeleteChargingStationTenancyResponse>(`${this.config.restApiUrl}/sharing/station`, {
                headers: {
                    Authorization: `Bearer ${this.authService.jwt}`,
                },
                body,
            } as any)
            .toPromise() as any as Promise<DeleteChargingStationTenancyResponse>;
    }

    /**
     * Get charging station tenants
     */
    async getChargingStationTenants(stationId: string): Promise<GetChargingStationTenantsResponse> {
        return this.http
            .get<GetChargingStationTenantsResponse>(
                `${this.config.restApiUrl}/sharing/station/${encodeURIComponent(stationId)}/tenants`,
                {
                    headers: {
                        Authorization: `Bearer ${this.authService.jwt}`,
                    },
                }
            )
            .toPromise();
    }
}

export interface DeleteChargingStationTenancyRequest {
    tenantId: string;
    stationId: string;
}

export interface DeleteChargingStationTenancyResponse {
    success: boolean;
}

export interface GetChargingStationTenantsResponse {
    tenantIds: string[];
    tenants: {
        tenantId: string;
        sharedTimestamp?: string;
    }[];
}

export interface PostChargingStationTenancyRequest {
    tenancy: PickStationTenancyBase;
}

export interface PostChargingStationTenancyResponse {
    success: boolean;
}

export interface PickStationTenancyBase {
    /**
     * Id of this station
     */
    stationId: string;
    tenantName?: string;
    /**
     * For which tenant this station is shared to
     */
    tenantId: string;
    /**
     * Is this tenant the owner or not
     */
    isOwner?: boolean;
    /**
     * Is this tenant allowed to share the station further
     */
    allowedToShare?: boolean;
}
